/**
 * RESPONSIBILITY: the Children's Ministry page's introduction band.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, Img, RenderOf } from '@framework/core/decorators';
import type { ImageValue } from '@framework/core';
import { SectionName } from '../section-names';
import { ABOVE_HINT } from '../hints';

@Section({ name: SectionName.ChildrenIntro, label: 'Children — introduction' })
export class ChildrenIntroSection {
  @Text({ label: 'Subtitle', maxLength: 300, description: ABOVE_HINT })
  introEyebrow!: string;

  @Text({ label: 'Title', maxLength: 300 })
  introHeading!: string;

  @Paragraph({ label: 'Description', maxLength: 20000, rows: 5, markdown: true, allow: ['verse'] })
  intro!: string;

  @RenderOf('intro')
  introHtml!: string;

  @Img({
    label: 'Image', folder: 'children', maxSizeMb: 12, size: '1200 × 900',
    description: 'The picture beside the text.',
  })
  introImage!: ImageValue;
}
